import React from 'react';
import styled from 'styled-components';
import DIAGRAM_SIZES from './constants/DiagramNumbers';

const StyledLineContainer = styled.div<{$top: string; $left: string}>`
  position: absolute;
  top: ${props => props.$top};
  left: ${props => props.$left};
  line {
    stroke: ${props => props.theme.text};
  }
  polygon {
    fill: ${props => props.theme.text};
  }
`;

interface NodeArrowsProps {
  top: string;
  left: string;
  width: number;
}

export default function NodeArrows({top, left, width}: NodeArrowsProps) {
  return (
    <StyledLineContainer $top={top} $left={left}>
      <svg height={DIAGRAM_SIZES.ARROW_SIZE_PX} width={width}>
        <polygon points="0,5 5,8 5,2" strokeWidth="1" />
        <polygon points="30,5 25,8 25,2" strokeWidth="1" />
        <line strokeWidth="1px" x1="1" y1="5" x2="29" y2="5" />
      </svg>
    </StyledLineContainer>
  );
}
